import React from "react";

import { FormTitle, LineDivider } from "components/layout";
import { AgentType } from "types";

import { PrimarySplitInformationFields } from "../primarySplitInformationFields";

type StraightSplitPrimarySplitInformationProps = {
	name: string;
	title: string;
	isLoading: boolean;
	splitInfo: { [key: string]: any };
	currentAgent?: AgentType;
	isEditing: boolean;
};

export const StraightSplitPrimarySplitInformation = ({
	name,
	title,
	isLoading = false,
	splitInfo,
	currentAgent,
	isEditing,
}: StraightSplitPrimarySplitInformationProps) => {
	return (
		<React.Fragment>
			<LineDivider />
			<FormTitle>
				<h3>{title}</h3>
			</FormTitle>

			<PrimarySplitInformationFields
				name={name}
				splitInfo={splitInfo}
				currentAgent={currentAgent}
				isLoading={isLoading}
				isEditing={isEditing}
				isStraightSplit={true}
			/>
		</React.Fragment>
	);
};
